<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-subscription">
      <div *ngIf='!channelSubscriptions || channelSubscriptions?.length === 0'>
        <div style="float:left">You don't have any subscriptions yet</div>
        <a routerLink='../channels' style="float: left; margin-left: 50px">
          <span>Add Channels </span>
          <i class="material-icons" style="vertical-align: middle">arrow_forward</i>
        </a>
      </div>
      <div class="bmw-md-subscriptions-list">
        <div *ngIf='channelSubscriptions && channelSubscriptions?.length > 0'>
          <div class="row bmw-no-gutter" style="margin-top: 7px">
            <div class="col-lg-6"></div>
            <div class="col-lg-6">
              <form class="input-group" name="findChannels">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
                  placeholder="Find Video" name="videoChannel" [(ngModel)]="search4video">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': (APP_SETTINGS.isRollsRoyce=== 'true')}"
                    class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button>
                </div>
              </form>
            </div>
          </div>
          <div style="width: 100%; margin:10px 5px 20px 5px">
            <div *ngFor='let channel of channelSubscriptions | paginate: { itemsPerPage: pageSize, currentPage: currentPage + 1, totalItems: totalElements }'>
              <div class="row bmw-no-gutter">
                <div class="col-lg-2 bmw-no-gutter bmw-sm-circle">
                  {{channel.channelNumber}}
                </div>
                <div class="col-lg-10 bmw-no-gutter" style="padding-left: 16px; font-size: 18px;">
                  <div style="float: left; padding-top: 6px; font-size:18px">{{channel.channelName}}</div>
                  <div style="float: left;margin-left: 40px; padding-top: 6px">
                    <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
                    <ng-template #thenBlock>
                      <div class="bmw-sm-videos-subscribe-btn checked"
                        [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true") ? "#281432" : "#1c69d4"}'>
                        <div class="col-lg-2 bmw-no-gutter"><i class="material-icons">check_circle</i></div>
                        <div class="col-lg-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                          Subscribed
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #elseBlock>
                      <div class="bmw-sm-videos-subscribe-btn unchecked">
                        <div class="col-lg-2 bmw-no-gutter"><i class="material-icons">add_circle_outline</i></div>
                        <div class="col-lg-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                          Subscribe
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px; margin-bottom: 15px" class="row bmw-no-gutter">
                <div
                  *ngFor='let video of channel.videos|searchFilter: "videoDisplayId,videoDisplayNumber,videoTitle": search4video; let indexOfelement=index;'>
                  <div *ngIf='indexOfelement < 6' class="pointer" style="float: left; margin-right: 12px;user-select: none">
                    <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/tisUI/#/playback"]'
                      [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
                      <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
                      <div class="bmw-lg-video-home-overlay-text"></div>
                    </div>
                    <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
                      <div class="row bmw-no-gutter">
                        <div class="col-lg-10 bmw-no-gutter">
                          <div class="row bmw-no-gutter">{{video.videoDisplayNumber }} </div>
                          <div class="row bmw-no-gutter"
                            [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                          </div>
                          <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                            {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                          </div>
                        </div>
                        <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                          <i class="material-icons pointer" style="opacity: 0.7"
                            data-toggle="dropdown">more_vert</i>
                          <ul class="dropdown-menu">
                            <li class="row bmw-no-gutter">
                              <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                                <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                              </div>
                              <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                                Add to wishlist
                              </div>
                            </li>
                            <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                              (click)='shareContent(video?.id, "video", video?.channel.channelNumber,  video?.videoDisplayNumber)'>
                              <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                                <i class="material-icons dp48" style="font-size:20px">share</i>
                              </div>
                              <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                                Share
                              </div>
                            </li>
                            <li class="divider"></li>
                            <li class="row bmw-no-gutter">
                              <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                                <i class="material-icons" style="font-size:20px">close</i>
                              </div>
                              <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                                Cancel
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a [routerLink]='["../channel-info", channel.channelNumber ]' *ngIf='channel.videos?.length > 6'>
                <div class="row bmw-no-gutter bmw-video-channel-btn bmw-button-secondary">Show More</div>
              </a>
            </div>
          </div>
          <!-- Pagination -->
          <div *ngIf='totalPages > 1' style="text-align: center; margin-top: 20px;">
            <pagination-controls 
              (pageChange)="goToPage($event - 1)"
              [maxSize]="5">
            </pagination-controls>
            <div style="margin-top: 10px; font-size: 14px;">
              Page {{ currentPage + 1 }} of {{ totalPages }} ({{ totalElements }} total channels)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipat HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md-subscription">
      <div *ngIf='!channelSubscriptions || channelSubscriptions?.length === 0'>
        <div style="float:left">You don't have any subscriptions yet</div>
        <a routerLink='../channels' style="float: left; margin-left: 50px">
          <span>Add Channels </span>
          <i class="material-icons" style="vertical-align: middle">arrow_forward</i>
        </a>
      </div>
      <div class="bmw-md-subscriptions-list">
        <div *ngIf='channelSubscriptions && channelSubscriptions?.length > 0'>
          <div class="row bmw-no-gutter" style="margin-top: 7px">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <form class="input-group" name="findChannels">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
                  placeholder="Find Video" name="videoChannel" [(ngModel)]="search4video">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': (APP_SETTINGS.isRollsRoyce=== 'true')}"
                    class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button>
                </div>
              </form>
            </div>
          </div>
          <div style="width: 100%; margin:10px 5px 20px 5px">
            <div *ngFor='let channel of channelSubscriptions | paginate: { itemsPerPage: pageSize, currentPage: currentPage + 1, totalItems: totalElements }'>
              <div class="row bmw-no-gutter">
                <div class="col-md-2 bmw-no-gutter bmw-sm-circle">
                  {{channel.channelNumber}}
                </div>
                <div class="col-md-10 bmw-no-gutter" style="padding-left: 16px; font-size: 18px;">
                  <div style="float: left; padding-top: 6px; font-size:18px">{{channel.channelName}}</div>
                  <div style="float: left;margin-left: 40px; padding-top: 6px">
                    <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
                    <ng-template #thenBlock>
                      <div class="bmw-sm-videos-subscribe-btn checked"
                        [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true")? "#281432":"#1c69d4"}'>
                        <div class="col-md-2 bmw-no-gutter"><i class="material-icons">check_circle</i></div>
                        <div class="col-md-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                          Subscribed
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #elseBlock>
                      <div class="bmw-sm-videos-subscribe-btn unchecked">
                        <div class="col-md-2 bmw-no-gutter"><i class="material-icons">add_circle_outline</i></div>
                        <div class="col-md-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                          Subscribe
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px; margin-bottom: 15px" class="row bmw-no-gutter">
                <div
                  *ngFor='let video of channel.videos?.slice(0,6) | searchFilter: "videoDisplayId,videoDisplayNumber,videoTitle": search4video'>
                  <div class="pointer" style="float: left; margin-right: 12px;user-select: none">
                    <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/tisUI/#/playback"]'
                      [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
                      <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
                      <div class="bmw-lg-video-home-overlay-text"></div>
                    </div>
                    <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
                      <div class="row bmw-no-gutter">
                        <div class="col-md-10 bmw-no-gutter">
                          <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                          <div class="row bmw-no-gutter"
                            [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                          </div>
                          <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                            {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                          </div>
                        </div>
                        <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                          <i class="material-icons pointer" style="opacity: 0.7"
                            data-toggle="dropdown">more_vert</i>
                          <ul class="dropdown-menu">
                            <li class="row bmw-no-gutter">
                              <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                                <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                              </div>
                              <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                                Add to wishlist
                              </div>
                            </li>
                            <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                              (click)='shareContent(video?.id, "video", video?.channel.channelNumber,  video?.videoDisplayNumber)'>
                              <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                                <i class="material-icons dp48" style="font-size:20px">share</i>
                              </div>
                              <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                                Share
                              </div>
                            </li>
                            <li class="divider"></li>
                            <li class="row bmw-no-gutter">
                              <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                                <i class="material-icons" style="font-size:20px">close</i>
                              </div>
                              <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                                Cancel
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a [routerLink]='["../channel-info", channel.channelNumber ]' *ngIf='channel.videos?.length > 6'>
                <div class="row bmw-no-gutter bmw-video-channel-btn bmw-button-secondary">Show More</div>
              </a>
            </div>
          </div>
          <!-- Pagination -->
          <div *ngIf='totalPages > 1' style="text-align: center; margin-top: 20px;">
            <pagination-controls 
              (pageChange)="goToPage($event - 1)"
              [maxSize]="5">
            </pagination-controls>
            <div style="margin-top: 10px; font-size: 14px;">
              Page {{ currentPage + 1 }} of {{ totalPages }} ({{ totalElements }} total channels)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-subscription">
      <div class="row bmw-no-gutter bmw-xs-row-subscription-header"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true")? "#281432":"#1c69d4"}'>
        <div class="col-sm-6 bmw-no-gutter" style="padding-left: 10px">
          <a *ngIf='channelSubscriptions && channelSubscriptions?.length > 0' routerLink='../manage-subscription'>Manage
            Subscriptions</a>
        </div>
        <div class="col-sm-6 bmw-no-gutter" style="text-align: right">
          <a routerLink='../channels'>
            <span>Add Channels </span>
            <i class="material-icons" style="vertical-align: middle">arrow_forward</i>
          </a>
        </div>
      </div>
      <div class="bmw-no-subscriptions-label" *ngIf='!channelSubscriptions || channelSubscriptions?.length === 0'>
        You don't have any subscriptions yet
      </div>
      <div *ngIf='channelSubscriptions && channelSubscriptions?.length > 0'>
        <div class="row bmw-no-gutter" style="margin-top: 7px">
          <form class="input-group" name="findChannels">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Video"
              name="videoChannel" [(ngModel)]="search4video">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style': (APP_SETTINGS.isRollsRoyce=== 'true')}"
                class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button>
            </div>
          </form>
        </div>
        <div style="width: 100%; margin:10px 5px 20px 5px">
          <div *ngFor='let channel of channelSubscriptions | paginate: { itemsPerPage: pageSize, currentPage: currentPage + 1, totalItems: totalElements }'>
            <div class="row bmw-no-gutter">
              <div class="col-sm-2 bmw-no-gutter bmw-sm-circle">
                {{channel.channelNumber}}
              </div>
              <div class="col-sm-10 bmw-no-gutter" style="padding-left: 16px; font-size: 18px;">
                <div style="float: left; padding-top: 6px; font-size:18px">{{channel.channelName}}</div>
                <div style="float: left;margin-left: 40px; padding-top: 6px">
                  <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
                  <ng-template #thenBlock>
                    <div class="bmw-sm-videos-subscribe-btn checked"
                      [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true")? "#281432":"#1c69d4"}'>
                      <div class="col-sm-2 bmw-no-gutter"><i class="material-icons">check_circle</i></div>
                      <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                        Subscribed
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #elseBlock>
                    <div class="bmw-sm-videos-subscribe-btn unchecked">
                      <div class="col-sm-2 bmw-no-gutter"><i class="material-icons">add_circle_outline</i></div>
                      <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                        Subscribe
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px; margin-bottom: 15px" class="row bmw-no-gutter">
              <div
                *ngFor='let video of channel.videos?.slice(0,6) | searchFilter: "videoDisplayId,videoDisplayNumber,videoTitle": search4video'>
                <div class="pointer" style="float: left; margin-right: 12px;user-select: none">
                  <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/tisUI/#/playback"]'
                    [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
                    <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
                    <div class="bmw-lg-video-home-overlay-text"></div>
                  </div>
                  <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
                    <div class="row bmw-no-gutter">
                      <div class="col-sm-10 bmw-no-gutter">
                        <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                        <div class="row bmw-no-gutter"
                          [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                        </div>
                        <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                          {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                        </div>
                      </div>
                      <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons pointer" style="opacity: 0.7"
                          data-toggle="dropdown">more_vert</i>
                        <ul class="dropdown-menu">
                          <li class="row bmw-no-gutter">
                            <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                              <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                              Add to wishlist
                            </div>
                          </li>
                          <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                            (click)='shareContent(video?.id, "video", video?.channel.channelNumber,  video?.videoDisplayNumber)'>
                            <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                              <i class="material-icons dp48" style="font-size:20px">share</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                              Share
                            </div>
                          </li>
                          <li class="divider"></li>
                          <li class="row bmw-no-gutter">
                            <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                              <i class="material-icons" style="font-size:20px">close</i>
                            </div>
                            <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                              Cancel
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a [routerLink]='["../channel-info", channel.channelNumber ]' *ngIf='channel.videos?.length > 6'>
              <div class="row bmw-no-gutter bmw-video-channel-btn bmw-button-secondary">Show More</div>
            </a>
          </div>
        </div>
        <!-- Pagination -->
        <div *ngIf='totalPages > 1' style="text-align: center; margin-top: 20px;">
          <pagination-controls 
            (pageChange)="goToPage($event - 1)"
            [maxSize]="5">
          </pagination-controls>
          <div style="margin-top: 10px; font-size: 14px;">
            Page {{ currentPage + 1 }} of {{ totalPages }} ({{ totalElements }} total channels)
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-subscription">
      <div class="row bmw-no-gutter bmw-xs-row-subscription-header"
        [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true") ? "#281432": "#1c69d4"}'>
        <div class="col-xs-6 bmw-no-gutter">
          <a *ngIf='channelSubscriptions && channelSubscriptions?.length > 0' routerLink='../manage-subscription'>Manage
            Subscriptions</a>
        </div>
        <div class="col-xs-6 bmw-no-gutter" style="text-align:right">
          <a routerLink='../channels'>
            <span>Add Channels </span>
            <i class="material-icons" style="vertical-align: middle">arrow_forward</i>
          </a>
        </div>
      </div>
      <div class="bmw-no-subscriptions-label" *ngIf='!channelSubscriptions || channelSubscriptions?.length === 0'>
        You don't have any subscriptions yet
      </div>
      <div *ngFor='let channel of channelSubscriptions | paginate: { itemsPerPage: pageSize, currentPage: currentPage + 1, totalItems: totalElements }' class="bmw-xs-video-suscription-info">
        <div class="row bmw-no-gutter">
          <div class="row bmw-no-gutter" style="margin-bottom: 15px">
            <div class="col-xs-8 bmw-no-gutter">
              <div class="col-xs-2 bmw-no-gutter bmw-xs-circle">
                {{channel.channelNumber}}
              </div>
              <div class="col-xs-9 bmw-no-gutter" style="padding-left: 4px; padding-top: 5px">
                {{channel.channelName}}
              </div>
            </div>
            <div class="col-xs-4 bmw-no-gutter" style="padding-top:5px">
              <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
              <ng-template #thenBlock>
                <div class="bmw-xs-videos-subscribe-btn checked"
                  [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce==="true") ? "#281432" : "#1c69d4"}'>
                  <div class="col-xs-2 bmw-no-gutter"><i class="material-icons">check_circle</i></div>
                  <div class="col-xs-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                    Subscribed
                  </div>
                </div>
              </ng-template>
              <ng-template #elseBlock>
                <div class="bmw-xs-videos-subscribe-btn unchecked">
                  <div class="col-xs-2 bmw-no-gutter"><i class="material-icons">add_circle_outline</i></div>
                  <div class="col-xs-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                    Subscribe
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter" *ngFor='let video of channel.videos?.slice(0,2)' style="margin-bottom:10px">
              <div class="col-xs-6 bmw-no-gutter">
                <a [routerLink]='["/playback"]'
                  [queryParams]='{channel: video.channel.channelNumber, video: video.id,  vimeoID: video.videoFileName,watchlist: false}'>
                  <img src="{{videoThumbnail}}" />
                  <!-- <video height="84px" width="150px" [src]='video?.videoFileName'></video> -->
                </a>
              </div>
              <div class="col-xs-5 bmw-no-gutter">
                <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber | highlightSearch: searchKey'>
                </div>
                <div class="row bmw-no-gutter"
                  [innerHTML]='video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle | highlightSearch: searchKey'>
                </div>
                <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
                  <div class="col-xs-6 bmw-no-gutter"
                    [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
                  <div class="col-xs-6 bmw-no-gutter" [innerHTML]='video.views'></div>
                </div>
              </div>
              <div class="col-xs-1 bmw-no-gutter">
                <div class="dropdown dropdown-pull-right btn-group">
                  <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter">
                      <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to wishlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber,  video?.videoDisplayNumber)'>
                      <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a [routerLink]='["../channel-info", channel.channelNumber]' *ngIf='channel.videos?.length > 6'>
          <div class="row bmw-no-gutter bmw-xs-video-channel-btn bmw-button-secondary">Show More</div>
        </a>
      </div>
      <!-- Pagination -->
      <div *ngIf='totalPages > 1' style="text-align: center; margin-top: 20px;">
        <pagination-controls 
          (pageChange)="goToPage($event - 1)"
          [maxSize]="3">
        </pagination-controls>
        <div style="margin-top: 10px; font-size: 12px;">
          Page {{ currentPage + 1 }} of {{ totalPages }}
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>